import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';


const ProtectedAdminRoute = ({ children, allowedRoles = ['ADMIN'] }) => {
  const { isAuthenticated, user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        Loading...
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} />;
  }

  const hasAccess = user && allowedRoles.includes(user.role);

  if (!hasAccess) {
    // If a moderator tries to access a super-admin page, send them back to moderation
    if (user.role === 'MODERATOR') {
      return <Navigate to="/moderationPage" />;
    }
    // Otherwise, send to home
    return <Navigate to="/" />;
  }

  return children;
};

export default ProtectedAdminRoute;
